import { bodyShadowBlur } from './BodyShadowStore';

export const updateBodyShadowBlur = (value) => bodyShadowBlur.update(oldValue => value);
